import { atom } from 'jotai'

export const baseUrlState = atom<string>('');
